import { canShowAction } from '../../../utils/actions/can-show-action';
import { CardAction } from '../../../view/Card/types';
import { getActionsFromJsonLd } from '../../common/actions/extractActions';
import { extractDownloadUrl } from '../../common/detail';
export var extractDownloadAction = function extractDownloadAction(data, actionOptions) {
  if (!canShowAction(CardAction.DownloadAction, actionOptions)) {
    return;
  }
  var downloadActionExists = getActionsFromJsonLd(data).find(function (action) {
    return action['@type'] === 'DownloadAction';
  });
  if (downloadActionExists) {
    return {
      downloadUrl: extractDownloadUrl(data)
    };
  }
  return;
};